import type { ReactNode } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Header } from './_shared';

export type CtaSlideProps = {
  eyebrow: ReactNode;
  title: ReactNode;
  /** Secondary line under the title (e.g. promo terms). */
  sub?: ReactNode;
  /** Both the QR target and the rendered URL string. */
  url: string;
  /** Optional promo code (rendered as a chip in the left column). */
  promoCode?: string;
  /** Optional validity / window line. */
  validity?: string;
  /** Optional secondary copy line in the left column. */
  extra?: ReactNode;
  /** Caption under the QR stage. Default "Scan to sign up". */
  qrCaption?: string;
  /** Optional right-side image (event layout). When set, the QR moves into the left column. */
  image?: { src: string; alt: string };
};

export function CtaSlide({
  eyebrow,
  title,
  sub,
  url,
  promoCode,
  validity,
  extra,
  qrCaption = 'Scan to sign up',
  image,
}: CtaSlideProps) {
  return (
    <div className="slide-body">
      <Header eyebrow={eyebrow} title={title} sub={sub} />
      <div className="sn-work sn-work--row">
        <div className="sn-cta-copy">
          {(promoCode || validity) && (
            <p className="sn-cta-promo">
              {promoCode && (
                <>
                  Code <code className="sn-cta-code">{promoCode}</code>
                </>
              )}
              {promoCode && validity ? ' · ' : null}
              {validity && <strong>{validity}</strong>}
            </p>
          )}
          {extra && <div className="sn-sub">{extra}</div>}
          {image && (
            <>
              <div className="sn-cta-qr-frame">
                <QRCodeSVG value={url} size={180} level="M" bgColor="#FFFFFF" fgColor="#151819" />
              </div>
              <span className="sn-mono">{qrCaption}</span>
            </>
          )}
        </div>
        {image ? (
          <div className="sn-image-panel sn-cta-image">
            <img src={image.src} alt={image.alt} />
          </div>
        ) : (
          <div className="sn-cta-stage">
            <div className="sn-cta-qr-frame">
              <QRCodeSVG value={url} size={220} level="M" bgColor="#FFFFFF" fgColor="#151819" />
            </div>
            <span className="sn-mono">{qrCaption}</span>
            <p className="sn-cta-url">{url}</p>
          </div>
        )}
      </div>
    </div>
  );
}
